exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pod-overview-card .pod-full-details-table {\n  padding-bottom: 16px; }\n", ""]);

// exports
